import { render, staticRenderFns } from "./faq-item.vue?vue&type=template&id=3c3ab692&scoped=true"
import script from "./faq-item.vue?vue&type=script&lang=js"
export * from "./faq-item.vue?vue&type=script&lang=js"
import style0 from "./faq-item.vue?vue&type=style&index=0&id=3c3ab692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3ab692",
  null
  
)

export default component.exports